<template>
  <v-row justify="center">
    <v-dialog
      :value="dialogProp"
      @click:outside="closeDialog()"
      scrollable
      max-width="500"
    >
      <v-card>
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
          rounded
          height="6"
        ></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Eliminar {{ item.name }}
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 350px">
            <v-form>
              <v-row dense>
                <v-col cols="12">
                  <v-card-text class="font-weight-medium ">
                    Esta seguro que desea eliminar este boton?
                  </v-card-text>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog()"
            >
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="loading"
              :disabled="loading"
              color="error"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="submitDelete"
            >
              Eliminar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  props: {
    item: {
      type: Object,
    },
    dialogProp: {
      type: Boolean,
      default: false,
    },
  },
  components: { vuescroll },
  data() {
    return {
      loading: false,
    };
  },

  methods: {
    closeDialog(itDelete = false) {
      this.$emit("dialog:close", itDelete);
    },

    async submitDelete() {
      this.loading = true;
      try {
        await PbxHttpClient.delete(`/admin/call_button/${this.item.id}`);
        this.$snotify.success("Boton eliminado con éxito.", "¡Hecho!");
        this.closeDialog(true);
      } catch (err) {
        console.error(err);
        this.$snotify.error("Hubo un error eliminando el boton ", "Error");
      }
      this.loading = false;
    },
  },
};
</script>
